import { Box, Stack, Typography } from '@mui/material'
import { useEffect } from 'react'
import ReactPlayer from 'react-player'
import { Icons } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { useSoundPlayer } from '@/core/resources'

import { SoundPlayerControl } from './SoundPlayerControl'

type Props = {
  uri: string
  autoplay?: boolean
}

export const SoundPurePlayer = ({ uri, autoplay }: Props) => {
  const {
    isUriUnavailable,
    player,
    playing,
    duration,
    sliderValue,
    handleDuration,
    handleProgress,
    change,
    commitChange,
    rewind,
    end,
    play,
    pause,
    forward,
    handleError,
  } = useSoundPlayer(uri)
  const { t } = useTranslation('postDetail')

  useEffect(() => {
    if (!(player && player.current)) return

    autoplay ? play() : pause()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player, autoplay])

  return (
    <Box sx={{ position: 'relative' }}>
      <>
        {isUriUnavailable && (
          <Box
            sx={{
              zIndex: 1,
              position: 'absolute',
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              display: 'grid',
              placeItems: 'center',
              userSelect: 'none',
            }}
          >
            <Stack
              spacing={2}
              alignItems="center"
              sx={{
                color: 'white',
              }}
            >
              <Stack spacing={1} direction="row" justifyContent="center">
                <Icons.Error fontSize="medium" />
                <Typography variant="h6" color="grey.300">
                  {t('resourceError')}
                </Typography>
              </Stack>
              <Typography variant="caption" color="grey.300">
                {t('resourceErrorDetail')}
              </Typography>
            </Stack>
          </Box>
        )}

        <ReactPlayer
          url={uri}
          ref={player}
          playing={playing}
          onDuration={handleDuration}
          onProgress={handleProgress}
          onEnded={end}
          onError={handleError}
          progressInterval={100}
          style={{ display: 'none' }}
          config={{
            file: {
              forceAudio: true,
              attributes: {
                controlsList: 'nodownload',
              },
            },
          }}
        />
        {player && (
          <SoundPlayerControl
            isPlaying={playing}
            duration={duration}
            onChange={change}
            onChangeCommitted={commitChange}
            sliderValue={sliderValue}
            onPlay={play}
            onPause={pause}
            onRewind={rewind}
            onForward={forward}
          />
        )}
      </>
    </Box>
  )
}
